import {
  QueryKey,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface FileHistoryShareRequest {
  historyId: string;
  isBulk?: boolean;
}

const fileHistoryShare = ({ historyId }: FileHistoryShareRequest) => {
  return api.put<ApiResponse<undefined>>('/file/history/share', {
    historyId,
  });
};

const fileBulkHistoryShare = ({ historyId }: FileHistoryShareRequest) => {
  return api.post<ApiResponse<undefined>>('/v2/viewer/submit/share', {
    historyId,
  });
};

const useFileHistoryShare = <TError = AxiosError<ApiErrorResponse>>(
  isBulk = false,
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    FileHistoryShareRequest,
    QueryKey
  >,
) => {
  return useMutation(isBulk ? fileBulkHistoryShare : fileHistoryShare, {
    ...options,
  });
};

export default useFileHistoryShare;
